<script setup lang="ts">
import HeroLegalContent from '~/components/pages/legal-content/Hero.vue'
import IconDocument from '~/components/icons/legal-content/IconDocument.vue'
import IntroductionSection from '~/components/pages/legal-content/terms-and-conditions/IntroductionSection.vue'
import UserCommitmentSection from '~/components/pages/legal-content/terms-and-conditions/UserCommitmentSection.vue'
import LiabilityAndWarrantiesSection from '~/components/pages/legal-content/terms-and-conditions/LiabilityAndWarrantiesSection.vue'
import UsersSection from '~/components/pages/legal-content/terms-and-conditions/UsersSection.vue'
import ForceMajeureSection from '~/components/pages/legal-content/terms-and-conditions/ForceMajeureSection.vue'
import IntellectualPropertySection from '~/components/pages/legal-content/terms-and-conditions/IntellectualPropertySection.vue'
import DataProtectionSection from '~/components/pages/legal-content/terms-and-conditions/DataProtectionSection.vue'
import ChangeAppSection from '~/components/pages/legal-content/terms-and-conditions/ChangeAppSection.vue'
import FinalProvisionsSection from '~/components/pages/legal-content/terms-and-conditions/FinalProvisionsSection.vue'

definePageMeta({
	layout: 'legal',
})

const { t: $t } = useI18n()

const getDescription = computed(() => {
	return `<p>${$t('These Terms and Conditions establish the rules and guidelines for using our website')}. ${$t('By accessing our services, you agree to these terms, which are designed to protect our intellectual property, limit our liability, and ensure a safe and reliable environment for all users')}.</p>`
})
</script>

<template>
	<div class="relative w-full bg-white">
		<div class="bg-[#f5f8fa]">
			<div class="flex flex-col items-center gap-10 sm:gap-24 pb-10 sm:pb-24">
				<!-- Hero Section -->
				<HeroLegalContent
					:title="$t('Our Terms and Conditions of Use')"
					:description="getDescription"
				>
					<template #icon>
						<IconDocument class="text-white size-10 sm:size-14" />
					</template>
				</HeroLegalContent>

				<!-- Content Section -->
				<div class="container">
					<div class="bg-white rounded-xl border border-gray-200 p-4 sm:p-14 space-y-10 sm:space-y-14">
						<!-- Introduction -->
						<IntroductionSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- User Commitment -->
						<UserCommitmentSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Liability and Warranties -->
						<LiabilityAndWarrantiesSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Users -->
						<UsersSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Force Majeure -->
						<ForceMajeureSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Intellectual Property -->
						<IntellectualPropertySection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Data Protection -->
						<DataProtectionSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Change to the App -->
						<ChangeAppSection />

						<div class="h-px bg-gray-200 mb-14"></div>

						<!-- Final Provisions -->
						<FinalProvisionsSection />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.text-gradient {
	background-clip: text;
	-webkit-background-clip: text;
	color: transparent;
	background-image: linear-gradient(to right, #4dd853, #233034);
}
</style>
